<template>
  <div>
    <rain-estimation-historical-data-type
      :types="types"
      :basins="basins"
      :searchResult="searchResult"
      dataType="summary"
      formInformationMessage="Os dados disponíveis variam de acordo com a opção de sumário selecionada (por dia e por mês)."
      @changeDataType="changeDataType($event)"
      @searchBasinData="searchBasinData($event)"
    ></rain-estimation-historical-data-type>
    <div v-if="searchResult">
      <rain-estimation-historical-search-result
        :searchResult="searchResult"
        :type="type"
        :types="types"
        :loadingOtherPeriod="loadingOtherPeriod"
        :loadingData="loadingData"
        @applyPeriod="applyPeriod($event)"
      ></rain-estimation-historical-search-result>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import RainEstimationHistoricalDataType from "./RainEstimationHistoricalDataType.vue";
import RainEstimationHistoricalSearchResult from "./RainEstimationHistoricalSearchResult.vue";
export default {
  name: "RainEstimationSummaryData",
  props: {
    basins: {
      type: Array,
      required: true,
    },
    searchResult: {
      type: Object,
    },
    loadingOtherPeriod: {
      type: Boolean,
    },
    loadingData: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RainEstimationHistoricalDataType,
    RainEstimationHistoricalSearchResult,
  },

  data: () => ({
    types: [],
    type: undefined,
  }),

  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      //const hourlyType = this.createHourlyType();
      const dailyType = this.createDailyType();
      const monthlyType = this.createMonthlyType();
      this.types = [dailyType, monthlyType];
    },

    // createHourlyType() {
    //   const hourlyType = {
    //     icon: "mdi-update",
    //     title: "Por hora",
    //     value: "horario",
    //   };
    //   const startDate = moment.tz("America/Sao_Paulo").startOf("day");
    //   const finalDate = moment.tz("America/Sao_Paulo").startOf("hour");
    //   const subtitle = `De ${startDate.format(
    //     "DD/MM/YYYY HH:mm"
    //   )} a ${finalDate.format("DD/MM/YYYY HH:mm")}`;
    //   const date_start = startDate.utc().format();
    //   const date_end = finalDate.utc().format();
    //   return { ...hourlyType, subtitle, date_start, date_end };
    // },
    createDailyType() {
      const dailyType = {
        icon: "mdi-calendar",
        title: "Por dia",
        value: "diario",
      };
      const startDate = moment().tz("America/Sao_Paulo").subtract(30, "days");
      const finalDate = moment().tz("America/Sao_Paulo");
      const subtitle = `De ${startDate.format(
        "DD/MM/YYYY"
      )} a ${finalDate.format("DD/MM/YYYY")}`;
      const date_start = startDate.format("YYYY-MM-DD");
      const date_end = finalDate.format("YYYY-MM-DD");
      return { ...dailyType, subtitle, date_start, date_end };
    },
    createMonthlyType() {
      const monthlyType = {
        icon: "mdi-calendar-month",
        title: "Por mês",
        value: "mensal",
      };
      const startDate = moment().tz("America/Sao_Paulo").subtract(12, "months");
      const finalDate = moment().tz("America/Sao_Paulo");
      const subtitle = `De ${startDate
        .locale("pt-br")
        .format("MM/YYYY")} a ${finalDate
        .locale("pt-br")
        .format("MM/YYYY")}`;
      const date_start = startDate.format("YYYY-MM");
      const date_end = finalDate.format("YYYY-MM");
      return { ...monthlyType, subtitle, date_end, date_start };
    },
    changeDataType(dataType){
      this.type = dataType.value;
      this.$emit("changeDataType", dataType);
    },
    searchBasinData(searchBasinDataParams){
      this.$emit("searchBasinData",{...searchBasinDataParams});
    },
    applyPeriod(periodSelected){
      this.$emit("applyPeriod", periodSelected);
    }
  },
};
</script>

<style>
</style>
